// Modal's HTTP layer 500s on any non-ASCII byte in a URL path, before the request
// reaches Percy. macOS screenshots ("... at 5.25.24 PM.png") hit this on every
// upload, so the name that goes into the path must be plain printable ASCII.
const toAsciiFileName = (name: string): string => {
  const ascii = name
    .normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .replace(/[^ -~]/gu, '_')
    .trim();
  return ascii || 'file';
};

export { toAsciiFileName };
